/* Company logos from logo.dev.

   Projects are usually named after a site, so when a project name looks like a domain we
   show that company's logo instead of the generic folder icon. If the name is not a domain,
   or the image fails to load, the icon stays — nothing depends on this working. */

const TOKEN = "pk_D2BgNsnrQT6SVBAQ0pvpOg";

/* Accepts "vedaroots.com", "www.vedaroots.com" or "https://vedaroots.com/path". */
export function domainFromName(name) {
  if (!name) return null;
  const trimmed = String(name).trim().toLowerCase();
  const withoutScheme = trimmed.replace(/^https?:\/\//, "").replace(/^www\./, "");
  const host = withoutScheme.split(/[/?#\s]/)[0];
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(host) ? host : null;
}

/* fallback=404 matters: without it logo.dev answers every unknown domain with a generic
   grey square, so a wrong guess would quietly replace the icon with a meaningless image.
   With it, an unknown domain fails cleanly and the folder icon stays. */
export function logoUrl(domain, size = 64) {
  return `https://img.logo.dev/${encodeURIComponent(domain)}` +
    `?token=${TOKEN}&size=${size}&format=png&retina=true&fallback=404`;
}

/* Returns markup for a project's badge: a logo when the name is a domain, otherwise the
   icon that was there before. The image removes itself if logo.dev has nothing. */
export function projectBadge(name, { fallbackIcon = "folder", color = "", domain: known = null } = {}) {
  const icon = `<i data-ic="${fallbackIcon}"${color ? ` style="color:${color}"` : ""}></i>`;
  /* Prefer the domain learnt from the uploaded URLs; fall back to reading the project name. */
  const domain = known || domainFromName(name);
  if (!domain) return icon;
  /* The icon is rendered alongside, hidden, so it is already painted and ready to take
     over the moment the logo fails to load. */
  const hiddenIcon = icon.replace("<i ", '<i style="display:none" ').replace('style="color:', 'data-color="');
  return `<img src="${logoUrl(domain)}" alt="" width="22" height="22" loading="lazy" ` +
    `style="border-radius:6px;object-fit:contain;flex-shrink:0" ` +
    `onerror="this.style.display='none';this.nextElementSibling.style.display=''">${hiddenIcon}`;
}
